const {
  REACT_APP_API_KEY,
  REACT_APP_BASE_URL,
  REACT_APP_DOMAIN,
  REACT_APP_PROJECT_ID,
  REACT_APP__STORAGE_BUCKET,
  REACT_APP_MESSAGE_SENDER_ID,
  REACT_APP_APP_ID,
  REACT_APP_MEASUREMENT_ID,
} = process.env;

const config = {
  firebase: {
    apiKey: REACT_APP_API_KEY,
    baseUrl: REACT_APP_BASE_URL,
    authDomain: REACT_APP_DOMAIN,
    projectId: REACT_APP_PROJECT_ID,
    storageBucket: REACT_APP__STORAGE_BUCKET,
    messagingSenderId: REACT_APP_MESSAGE_SENDER_ID,
    appId: REACT_APP_APP_ID,
    measurementId: REACT_APP_MEASUREMENT_ID,
  },
};

export default config;
